<template>
  <div class="imgContain relative">
    <div class=" contact text-center" :class="{fixed:isFix,absolute:isabsolute}">
      <span class="color-white h68 block lh68 ft20 contactTitle">{{this.contactTitle}}</span>
      <ul class="contactList ft16">
        <li v-for="(item,index) in this.contactList" :class="{current:(index==cur_pos)}" @click="changeCurrent(index)"><a>{{item.listTitle}}</a></li>
      </ul>
    </div>
  </div>
</template>

<script>
 import bus from '@/assets/js/bus'
export default {
  name: 'imgApp',
  props:{
    contactTitle:String,
    contactList:Array,

  },
  data () {
    return {
     default:1,
     cur_pos:0,
     oldpos:null,
     newpos:null,
     isFix:false,
     isabsolute:true
      
    }
  },
  methods:{
   changeCurrent(index){
      //获取需要滚动的距离
      //let scrollHeight=contactList[index].offsetTop;
     
      bus.$emit('navHash',index);
      this.cur_pos=index
   },
   handleScroll(){
      let scrollTop = $(window).scrollTop();
      //console.log($('.contact'))
      //let bannerHeight=$('.contact').position().top;
      //console.log(scrollTop,bannerHeight)
      if(scrollTop>458){
        this.isabsolute=false;
        this.isFix=true;
        $('.contact').css({
          'top':'130px',
        })
      }
      else{
        this.isFix=false;
        this.isabsolute=true;
        $('.contact').css({
          'top':'532px',
        })
      }
   }
  },
  created(){
    bus.$on('navChange',(index)=>{
      this.cur_pos=index
    })
  },
  mounted(){
    this.$nextTick(function () {
    window.addEventListener('scroll', this.handleScroll)
    });
  },
    destroyed(){
      window.removeEventListener('scroll', this.handleScroll);
  },
  components:{
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.imgContain{height: 600px;background-size: cover;}
.contact{ 
  margin-left:50%;
  /* top:292px; */
  top:532px;
  left:-584px;
  width: 170px;
  
}
.contact .contactTitle{
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  background-color:#00aaff; 
}
.contact .contactList{
  background-color: #fff;
  color:#545759;
  border-left:1px solid #d8e1e6;
  border-bottom:1px solid #d8e1e6;
  border-right:1px solid #d8e1e6;
  border-bottom-left-radius:6px;
  border-bottom-right-radius:6px;
}
.contactList li{
  height:52px;
  line-height:52px;
}
.contactList li:hover{
  color:#00aaff;
  cursor: pointer;
  font-weight: 600;
}
.contact .contactList .current{
  color:#00aaff;
  background: url(../../../static/images/current_title.png) no-repeat 36px center ;
  font-weight: 600;
}
.contact .contactList .currentBlock{
  width:8px;
  height: 8px;
  background-color: #00aaff;
}
@media (max-width: 1240px){
.contact{
      left:-516px;
    }
}
@media (max-width: 1168px){
.contact{
      width:110px; 
      left:-460px;
  }
.contact .contactList .current{

    background-position: 9px center ;

  }
}
@media (max-width: 1010px){
  .contact{
      left:-384px;
  }
}
@media (max-width: 840px){
  .contact{
      left:-342px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/common/imgApp.vue